module.exports = __webpack_public_path__ + "media/images/seccional-30edb436.png";